// extracted by mini-css-extract-plugin
module.exports = {"intlSettingModal":"IntlSettingModal_intlSettingModal__22TNt"};